import React from 'react';
import { DropdownSelector } from 'library';

const JobFilterDropdown = ({ value, options = [], label, onChange }) => {
  const formattedOptions = options.map((val) => ({ label: val, value: val }));
  formattedOptions.unshift({ label: 'All', value: 'All' });

  return (
    <div>
      <DropdownSelector
        value={value}
        formatOptionLabel={(option, meta) => {
          if (meta.context === 'value' && option.value === 'All') {
            return label;
          }
          return option.label;
        }}
        options={formattedOptions}
        onChange={onChange}
      />
    </div>
  );
};

export default JobFilterDropdown;
